
import React from 'react';
import { X } from 'lucide-react';

interface PrivacyModalProps {
  onClose: () => void;
}

const PrivacyModal: React.FC<PrivacyModalProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
          <h2 className="text-2xl font-bold text-gray-900">Privacy Policy</h2>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        <div className="p-6 space-y-6">
          <div>
            <h3 className="text-lg font-semibold mb-3">Information We Collect</h3>
            <p className="text-gray-600 mb-4">
              We collect information you provide directly to us, such as when you create an account, 
              subscribe to our newsletter, or contact us for support.
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-1">
              <li>Name and email address</li>
              <li>Phone number (optional)</li>
              <li>Professional information (optional)</li>
              <li>Communication preferences</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">How We Use Your Information</h3>
            <ul className="list-disc pl-6 text-gray-600 space-y-1">
              <li>Send you deal alerts and newsletters</li>
              <li>Personalize your experience</li>
              <li>Respond to your inquiries</li>
              <li>Improve our services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">Information Sharing</h3>
            <p className="text-gray-600">
              We do not sell, rent, or share your personal information with third parties for their 
              marketing purposes. We may share information in the following circumstances:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-2">
              <li>With your consent</li>
              <li>To comply with legal requirements</li>
              <li>To protect our rights and safety</li>
              <li>With service providers who assist our operations</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">Data Security</h3>
            <p className="text-gray-600">
              We implement appropriate security measures to protect your personal information against 
              unauthorized access, alteration, disclosure, or destruction.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">Your Rights</h3>
            <ul className="list-disc pl-6 text-gray-600 space-y-1">
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Delete your information</li>
              <li>Unsubscribe from communications</li>
              <li>Data portability</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">Contact Us</h3>
            <p className="text-gray-600">
              If you have questions about this Privacy Policy, please contact us at help@discountpro.org.
            </p>
          </div>

          <div className="text-sm text-gray-500">
            Last updated: January 2025
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModal;
